
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AreaSearchAdditionalFieldsSettingResponse, AdditionalFieldState }  from "@/types/area-tree-select/AreaSearchAdditionalFieldsSettingResponse";
import { CustomFieldDto } from "@/store/custom-fields/types";
import { GroupAdvancedSearchQuery } from "@/types/sv-data/groups/AreaNode";

@Component({
})
export default class AdditionalFields extends Vue {
    @Prop({type: Array, default: []})
    allAdditionalSearchFields: AreaSearchAdditionalFieldsSettingResponse[];
 
    @Prop({type: Array, default: []})
    areaCustomFields: CustomFieldDto[];

    @Prop(Object)
    lastAdvancedSearchQuery: GroupAdvancedSearchQuery;

    @Prop({ type: Boolean, default: false}) isShowingAdvancedSearchResults: boolean;

    private badgeLimit: number = 5;
    private titleField: AdditionalFieldState = {
        title: "Title", 
        isCustomField: false,
        customFieldTitle: ""
    };

    private additionalSearchFields: AdditionalFieldState[] = [];

    private async mounted(): Promise<void> {
        this.buildDisplayOfAdditionalFields();
    }

    @Watch("isShowingAdvancedSearchResults")
    private updateFieldsToShow(): void {
        this.buildDisplayOfAdditionalFields();
    }

    private buildDisplayOfAdditionalFields(): void {
        let fieldsToShow = this.isShowingAdvancedSearchResults ? this.convertAdvancedSearchFields : this.allAdditionalSearchFields;
        this.additionalSearchFields = this.isShowingAdvancedSearchResults ? [] : [this.titleField] as AdditionalFieldState[];
		fieldsToShow.forEach((field) => {
            let additionalSearchField = {
                title: field.title, 
				isCustomField: field.isCustomField,
            } as AdditionalFieldState;

            if (field.isCustomField) {
                additionalSearchField.customFieldTitle = this.areaCustomFields.find(cf => cf.id == field.title)?.title;
            }

			this.additionalSearchFields.push(additionalSearchField);
		})
	}

    private get convertAdvancedSearchFields(): AreaSearchAdditionalFieldsSettingResponse[] {
		var convertedFields = [];
		if (!this.lastAdvancedSearchQuery) {
			return [];
		} else {
			if (this.lastAdvancedSearchQuery.title && this.lastAdvancedSearchQuery.title != "") {
				convertedFields.push(this.titleField)
			}

			if (this.lastAdvancedSearchQuery.referenceId && this.lastAdvancedSearchQuery.referenceId != "") {
				convertedFields.push({
					title: "Reference ID",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

			if (this.lastAdvancedSearchQuery.address && this.lastAdvancedSearchQuery.address != "") {
				convertedFields.push({
					title: "Address",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

			if (this.lastAdvancedSearchQuery.telephonePrimary && this.lastAdvancedSearchQuery.telephonePrimary != "") {
				convertedFields.push({
					title: "Primary Telephone",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

			if (this.lastAdvancedSearchQuery.telephoneSecondary && this.lastAdvancedSearchQuery.telephoneSecondary != "") {
				convertedFields.push({
					title: "Secondary Telephone",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

			if (this.lastAdvancedSearchQuery.telephoneFire && this.lastAdvancedSearchQuery.telephoneFire != "") {
				convertedFields.push({
					title: "Fire Telephone",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

			if (this.lastAdvancedSearchQuery.telephonePolice && this.lastAdvancedSearchQuery.telephonePolice != "") {
				convertedFields.push({
					title: "Police Telephone",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

			if (this.lastAdvancedSearchQuery.timeZoneId) {
				convertedFields.push({
					title: "Time Zone",
					isCustomField: false
				} as AreaSearchAdditionalFieldsSettingResponse)
			}

            if (this.lastAdvancedSearchQuery != null) {
                this.lastAdvancedSearchQuery.customFieldSearchQueries.forEach((customField) => {
                    if (customField.searchQuery && customField.id && customField.searchQuery != "") {
                        convertedFields.push({
                            title: customField.id,
                            isCustomField: true
                        } as AreaSearchAdditionalFieldsSettingResponse)
                    }
			    })
            }
		}

		return convertedFields;
	}

    private getAdditionalFieldName(field: AdditionalFieldState): string {
        return field.isCustomField ? field.customFieldTitle : field.title
    }
}
